import * as types from '../types/activityTypes';
import * as activityService from '../../services/activityService';

export const fetchMyActivity = () => async (dispatch) => {
  dispatch({ type: types.FETCH_MY_ACTIVITY_REQUEST });
  try {
    const data = await activityService.getMyActivity();
    dispatch({ type: types.FETCH_MY_ACTIVITY_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: types.FETCH_MY_ACTIVITY_FAILURE,
      payload: err?.message || 'Failed to load activity',
    });
  }
};

